import React from 'react';
import * as PhosphorIcons from '@phosphor-icons/react'; // eslint-disable-line no-restricted-imports
import CustomIconBase from '@components/shared/CustomIcon/CustomIconBase';
import { CUSTOM_ICONS } from '@components/shared/CustomIcon/CustomIcons';
import { resolveThemeColor } from '@utils/Functions';

type CustomIconProps = {
  name: string;
  size?: number;
  color?: string;
  weight?: 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
  mirrored?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const PageDefaultIcon = ({
  size = 24,
  color,
}: {
  size?: number;
  color?: string;
}) => <PhosphorIcons.Note size={size} color={color} />;

const CustomIcon = React.forwardRef<SVGSVGElement, CustomIconProps>(
  ({ name, size, color, weight, mirrored, ...props }, ref) => {
    const SelectedPhosphorIcon = (PhosphorIcons as any)[name];

    if (SelectedPhosphorIcon) {
      return (
        <SelectedPhosphorIcon
          ref={ref}
          size={size}
          color={resolveThemeColor(color)}
          weight={weight}
          mirrored={mirrored}
        />
      );
    }
    if (CUSTOM_ICONS[name]) {
      return (
        <CustomIconBase
          ref={ref}
          paths={CUSTOM_ICONS[name]}
          size={size}
          color={color}
          {...props}
        />
      );
    }
    return <PageDefaultIcon size={size} color={color} />;
  },
);

export default CustomIcon;
